"use client"
import { Menu, rem } from "@mantine/core"
import {
  IconCalendarStats,
  IconList,
  IconListDetails,
} from "@tabler/icons-react"

import { NavbarButtonWithMenu } from "@/components/generic/SideNavBar/components/NavbarButtonWithMenu"
import { useRouter } from "next-nprogress-bar"
import { useAppStore } from "@/app/(store)/appStore"
import { isDJUIEnabled } from "@/lib/featureFlags.utils"
import dynamic from "next/dynamic"

const MenuItemPowerDialerButton = dynamic(
  () =>
    import("./clientComponents").then((mod) => mod.MenuItemPowerDialerButton),
  {
    ssr: false,
  }
)

interface NavbarPowerDialerButtonProps {
  isSelected: boolean
  isSidebarMenuExpanded: boolean
}

export function NavbarPowerDialerButton({
  isSelected,
  isSidebarMenuExpanded,
}: NavbarPowerDialerButtonProps) {
  const router = useRouter()
  const changeSidebarMenuState = useAppStore(
    (state) => state.changeSidebarMenuState
  )

  function handleClick(href: string) {
    changeSidebarMenuState(false)
    router.push(href)
  }

  return (
    <NavbarButtonWithMenu
      icon={IconList}
      isSelected={isSelected}
      isSidebarMenuExpanded={isSidebarMenuExpanded}
    >
      <Menu.Dropdown miw={200}>
        <MenuItemPowerDialerButton
          onClick={() => handleClick("/power-dialer")}
        />
        <Menu.Item
          // component={Link}
          // href="/scheduled/calls"
          leftSection={
            <IconCalendarStats style={{ width: rem(14), height: rem(14) }} />
          }
          onClick={() => handleClick("/scheduled/calls")}
        >
          Scheduled Calls
        </Menu.Item>
      </Menu.Dropdown>
    </NavbarButtonWithMenu>
  )
}
